
import { greatestDivisibleBy } from '~/fc/helpers'
export default {
  name: 'ContentCardList',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
      default: {}
    }
  },
  computed: {
    borderLimit () {
      if (!(this.value.items && this.value.items.length)) { return 0 }
      const limit = greatestDivisibleBy(this.value.items.length, 3)
      return this.value.items.length > limit ? limit : limit - 3
    }
  }
}
